// カート内のレイアウトをカスタマイズ - 15色セット商品用（修正版）
(function() {
  
  function customizeCart() {
    // カート内のすべての商品行を取得
    const cartItems = document.querySelectorAll('.cart-item, [data-cart-item], .product-row, .cart__item');
    
    cartItems.forEach(function(itemRow, index) {
      // 商品タイトルを取得
      let titleElement = itemRow.querySelector('.product-title, .title, h2, h3, a');
      if (!titleElement) return;
      
      const productTitle = titleElement.textContent || titleElement.innerText;
      
      // 15色セット商品かどうかを判定
      if (!productTitle.includes('15色セット')) return;
      
      // 既に処理済みかチェック
      if (itemRow.classList.contains('set-qty-processed')) return;
      itemRow.classList.add('set-qty-processed');
      
      // ========================================
      // セット数を計算（数量から逆算）
      // ========================================
      const quantityInput = itemRow.querySelector('input[type="number"]');
      if (!quantityInput) return;
      
      const actualQuantity = parseInt(quantityInput.value) || 45;
      const setQuantity = Math.round(actualQuantity / 15);
      
      // ========================================
      // 数量行のコンテナを見つける
      // ========================================
      let quantityContainer = quantityInput.closest('.quantity-selector, .quantity, .quantity-input, .cart__item-quantity');
      if (!quantityContainer) {
        quantityContainer = quantityInput.parentElement;
      }
      
      // ========================================
      // 1. 数量入力フィールドを非表示
      // ========================================
      quantityInput.style.display = 'none';
      
      // 元のinput周辺のコントロール（−/+ボタンなど）も非表示
      const minusBtn = quantityContainer.querySelector('[data-quantity-minus], .quantity-minus, button[aria-label*="減"]');
      const plusBtn = quantityContainer.querySelector('[data-quantity-plus], .quantity-plus, button[aria-label*="増"]');
      
      if (minusBtn) minusBtn.style.display = 'none';
      if (plusBtn) plusBtn.style.display = 'none';
      
      // ========================================
      // 2. セット数表示＋制御ボタンを作成
      // ========================================
      const setQtySection = document.createElement('div');
      setQtySection.style.cssText = `
        margin-bottom: 12px;
        padding: 10px;
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 4px;
      `;
      
      const setQtyLabel = document.createElement('div');
      setQtyLabel.style.cssText = `
        font-size: 12px;
        color: #666;
        margin-bottom: 8px;
      `;
      setQtyLabel.textContent = 'セット数';
      
      const setQtyControl = document.createElement('div');
      setQtyControl.style.cssText = `
        display: flex;
        align-items: center;
        gap: 10px;
      `;
      
      // −ボタン
      const minusSetBtn = document.createElement('button');
      minusSetBtn.type = 'button';
      minusSetBtn.textContent = '−';
      minusSetBtn.style.cssText = `
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #ccc;
        background-color: #fff;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
      `;
      
      // セット数表示
      const setQtyDisplay = document.createElement('div');
      setQtyDisplay.style.cssText = `
        font-size: 18px;
        font-weight: bold;
        min-width: 40px;
        text-align: center;
        color: #333;
      `;
      setQtyDisplay.textContent = setQuantity + ' セット';
      
      // +ボタン
      const plusSetBtn = document.createElement('button');
      plusSetBtn.type = 'button';
      plusSetBtn.textContent = '+';
      plusSetBtn.style.cssText = `
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #ccc;
        background-color: #fff;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
      `;
      
      setQtyControl.appendChild(minusSetBtn);
      setQtyControl.appendChild(setQtyDisplay);
      setQtyControl.appendChild(plusSetBtn);
      
      setQtySection.appendChild(setQtyLabel);
      setQtySection.appendChild(setQtyControl);
      
      quantityContainer.parentElement.insertBefore(setQtySection, quantityContainer);
      
      // ========================================
      // 3. 実数量表示（固定）
      // ========================================
      const actualQtySection = document.createElement('div');
      actualQtySection.style.cssText = `
        margin-bottom: 12px;
        padding: 10px;
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 13px;
        color: #666;
      `;
      actualQtySection.innerHTML = `
        <div style="margin-bottom: 4px;">実数量（変更不可）</div>
        <div style="font-size: 16px; font-weight: bold; color: #333;">${actualQuantity}個</div>
      `;
      
      quantityContainer.parentElement.insertBefore(actualQtySection, quantityContainer);
      
      // ========================================
      // 4. ボタンクリックイベント
      // ========================================
      let currentSetQty = setQuantity;
      
      minusSetBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentSetQty > 1) {
          currentSetQty--;
          updateDisplay();
        }
      });
      
      plusSetBtn.addEventListener('click', function(e) {
        e.preventDefault();
        currentSetQty++;
        updateDisplay();
      });
      
      function updateDisplay() {
        const newActualQty = currentSetQty * 15;
        setQtyDisplay.textContent = currentSetQty + ' セット';
        actualQtySection.querySelector('div:last-child').textContent = newActualQty + '個';
        quantityInput.value = newActualQty;
        
        // Shopifyカート更新APIを呼び出す
        updateShopifyCart(index, newActualQty);
      }
      
      function updateShopifyCart(lineIndex, newQty) {
        // 全商品の数量を集める
        const updates = {};
        let lineCount = 0;
        
        document.querySelectorAll('.cart-item, [data-cart-item]').forEach(function(row) {
          const input = row.querySelector('input[type="number"]');
          if (input) {
            updates[lineCount] = parseInt(input.value) || 0;
            lineCount++;
          }
        });
        
        // 対象行を更新
        updates[index] = newQty;
        
        // Shopifyのカート更新API
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).catch(err => console.log('Cart update error:', err));
      }
    });
  }
  
  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', customizeCart);
  } else {
    customizeCart();
  }
  
  // カート動的更新に対応
  const observer = new MutationObserver(function() {
    setTimeout(customizeCart, 200);
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('カート内レイアウト: 初期化完了');
})();